export default __webpack_public_path__ + "b9b8d58c3b7230c81c74606cca0c7e52.svg";